{
    "Profile_Drivers_Suspension.drivingSuspension": "FR: Driving Suspension",
    "Profile_Drivers_Suspension.drivingSuspensionDetails": "FR: Driving Suspension Details",
    "Profile_Drivers_Suspension.startDate": "FR: Start Date",
    "Profile_Drivers_Suspension.endDate": "FR: End Date",
    "Profile_Drivers_Suspension.reinstatementDate": "FR: Reinstatement Date",
    "Profile_Drivers_Suspension.relatedConviction": "FR: Related Conviction"
}
